import { AppletPreview } from "@/components/artifacts/AppletPreview.tsx";
import { useArtifactViewCtx } from "@/components/artifacts/view/ArtifactViewContext.tsx";
import type { ArtifactComponent } from "@/types/artifacts-view.ts";

type AppletPreviewComponentData = Extract<ArtifactComponent, { type: "appletPreview" }>;

export const AppletPreviewBlock = ({ component }: { component: AppletPreviewComponentData }) => {
  const {
    threadId,
    messageId,
    artifactId,
    isSharedThread,
    appletPreviewSrc,
    onRequestClose,
    fill,
  } = useArtifactViewCtx();
  return (
    <AppletPreview
      threadId={threadId}
      messageId={messageId}
      artifactId={artifactId}
      title={component.title}
      appletUrn={component.urn}
      // No session to post a fix message from on a shared (unauthenticated)
      // view, and nothing to fix on someone else's applet.
      canRequestFix={!isSharedThread && appletPreviewSrc === undefined}
      sharedPreviewSrc={appletPreviewSrc}
      // Closes the lightbox after a fix is sent, surfacing the thread.
      onRequestClose={onRequestClose}
      fill={fill}
    />
  );
};
